import React from "react";
import "./Skills.css";
import UIDesign from "../../assets/3dicons/uix.png";
import WebDesign from "../../assets/3dicons/websitedes.png";
import AppDesign from "../../assets/3dicons/phone.png";

const Skills = () => {
  return (
    <section id="skills">
      <h1 className="skillTitle">What I do</h1>
      <p className="skillTitle">
        I am skilled and passionate web designer with experience in creating{" "}
        <br />
        visually appealing and user-friendly websites. <br />I have a strong
        understanding of design and a keen eye for detail. <br />I am proficient
        in HTML , CSS and javascript as well as design software such as adobe
        photoshop and illustrator.
      </p>
      <p className="skillTitle">
        Please drag or press the cursor over the features.
      </p>
      <div className="skillBars">
        <div className="skillBar">
          <img src={UIDesign} alt="UI Design" />
          <div className="skillBarText">
            <h2>UI/UX designer</h2>
            <p>
              User Interface I work on user experience. I use the figma program
              to optimize this feature.
            </p>
          </div>
        </div>
        <div className="skillBar">
          <img src={WebDesign} alt="Web Design" />
          <div className="skillBarText">
            <h2>Web Designer / Front End Developer</h2>
            <p>
              I met front end when I started university in 2020, and even that
              was the first time I met software. Front end has always intrigued
              me. Design processes allow my imagination to come true.
            </p>
          </div>
        </div>
        <div className="skillBar">
          <img src={AppDesign} alt="App Design" />
          <div className="skillBarText">
            <h2>App Designer / Flutter developer</h2>
            <p>
              I was introduced to the Flutter language in 2022, but I was not
              very familiar with it. I started again in 2023 and I'm constantly
              trying to get myself to the top.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
